module.exports = __webpack_public_path__ + "static/media/convective-icon-slight.540f2aa3.svg";